import { translations } from './translations/i18n';
import { writable, get } from 'svelte/store';
import { getLang } from './utils/window';
const lang = getLang();
const translationStore = writable(translations[lang]);
export const translation = get(translationStore);
